"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get an accessor to the table.
 * @param label List of labels.
 * @param table Table.
 */
exports.default = ({ label, table, }) => ({ x = 0, y = 0 }) => { var _a; return label[(_a = table[y]) === null || _a === void 0 ? void 0 : _a[x]]; };
//# sourceMappingURL=create2DAccessor.js.map